import {mergeObjects} from "../../mergeObjects";

export default class NodesMerger {
    // Public:
    compute(rawNodes) {
        this.rawNodes = rawNodes;
        this.mergedNodes = [];
        for (let i = 0; i < rawNodes.length; i++) {
            const rawNode = rawNodes[i];
            const coincidences = this.findCoincidencesById(rawNode);
            if (coincidences.length > 0) {
                const mergedNode = this.mergeNodes(coincidences);
                this.mergedNodes.push(mergedNode);
            }
        }
        return this.mergedNodes;
    }

    // Private:
    findCoincidencesById(node) {
        const id = node["id"];
        let coincidences = [];
        if (this.mergedNodes.filter(node => node.id === id).length === 0) {
            coincidences = this.rawNodes.filter(node => node.id === id);
        }
        return coincidences;
    }

    mergeNodes(coincidences) {
        let merged = {};
        for (let i = 0; i < coincidences.length; i++) {
            const duplicate = coincidences[i];
            merged = mergeObjects(merged, duplicate, true);
        }
        return merged;
    }
}
